import React from 'react';
import { Table } from 'reactstrap';
import './Panel.css'

class Panel extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.band = {
      CBand: 'C-band',
      BDBand: 'Ku-band Bangladesh',
      IndoBand: 'Ku-band Indonesia',
      IndiaBand: 'Ku-band India Plus',
      PhBand: 'Ku-band Philippines'
    }
  }

  componentWillReceiveProps(nextProps) {
    this.props = nextProps;
  }

  render(){
   return (
    <div className="Panel">
      <p className="panel-header">
        <b>Reception Details</b>
      </p>
      <div className="panel-sat-detail">
        <p>119.1° E-Bangabandhu-1</p>
      </div>
      <div className="panel-title">
        <b>{this.band[this.props.band]}</b>
      </div>
      <div className="panel-body">
        <Table bordered>
          <tbody>
            <tr>
              <td>Latitude (N=+,S=-)</td>
              <td>{this.props.satelliteVar.stationPosition[1].toFixed(2)}°</td>
            </tr>
            <tr>
              <td>Longitude (E=+,W=-)</td>
              <td>{this.props.satelliteVar.stationPosition[0].toFixed(2)}°</td>
            </tr>
            <tr>
              <td>Elevation angle</td>
              <td>{this.props.satelliteVar.elevationAngle.toFixed(2)}°</td>
            </tr>
            <tr>
              <td>Azimuth angle</td>
              <td>{this.props.satelliteVar.azimuthAngle.toFixed(2)}°</td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
   ); 
  }
}

export default Panel;